module.exports = externalMods.get("ws");